import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { WorkforcePersonMatchDto } from 'src/shared/services/api.service';

@Component({
  selector: 'cert-workforce-add-staff-lookup-step',
  templateUrl: './workforce-add-staff-lookup-step.component.html',
  styleUrl: './workforce-add-staff-lookup-step.component.scss',
  standalone: false,
})
export class WorkforceAddStaffLookupStepComponent {
  @Input() canCreatePerson = false;
  @Output() createPerson = new EventEmitter<void>();
  @Input() ein = '';
  @Input() fields = { firstName: '', lastName: '', ssn: '', edShId: '' };
  @Input() hasMoreMatches = false;
  @Output() fieldsChanged = new EventEmitter<{
    field: 'firstName' | 'lastName' | 'ssn' | 'edShId';
    value: string;
    form: NgForm;
  }>();
  @Input() isSearching = false;
  @Input() error: string | null = null;
  @Input() searchedEin: string | null = null;
  @Input() matches: WorkforcePersonMatchDto[] = [];
  @Input() selectedPerson: WorkforcePersonMatchDto | null = null;
  @Input() errorEmitter!: EventEmitter<{ modelErrors: string[][]; allErrors: string[][] } | null>;

  @Output() einChanged = new EventEmitter<{ value: string; form: NgForm }>();
  @Output() personSelected = new EventEmitter<WorkforcePersonMatchDto>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() continueToEmployment = new EventEmitter<void>();
}
